const initialState = {
    items: [],
    single: {},
    refresh: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'MENU_RESET':
            return initialState;

        case '@@router/LOCATION_CHANGE':
            if (!action.payload.pathname.startsWith('/workspace/')) {
                return {
                    ...state,
                    single: {}
                };
            } else {
                return state;
            }
            
        case 'HIDE_SUB_BAR':
            return {
                ...state,
                single: {}
            };
            
        case 'MENU_SINGLE_SUCCESS':
            let menuData = null;
            let initialValues = {};
            let single = action.payload.data;
            
            initialValues.title = false;
            
            if (single) {
                menuData = JSON.parse(single.menuData[0].data);

                initialValues = {
                    title: menuData.title,
                    url: menuData.url,
                    contentId: menuData.contentId
                };

                // if (menuData.externalUrl) {
                //     initialValues.externalUrl = {
                //         title: menuData.externalUrl.title,
                //         url: menuData.externalUrl.url
                //     }
                // }

                // if (menuData.internalUrl) {
                //     initialValues.internalUrl = {
                //         title: menuData.internalUrl.title,
                //         contentId: menuData.internalUrl.contentId
                //     }
                // }

                if (menuData.parentNodeId) {
                    initialValues.parentNodeId = menuData.parentNodeId;
                } else {
                    initialValues.parentNodeId = null;
                }

                single.title = initialValues.title;
                single.url = initialValues.url;
                single.contentId = initialValues.contentId;
                // single.externalUrl = initialValues.externalUrl;
                // single.internalUrl = initialValues.internalUrl;
                // single.parentNodeId = initialValues.parentNodeId;
            }

            return {
                ...state,
                single: single
            };
            
        case 'MENU_GET_SUCCESS':
            return {
                ...state,
                items: action.payload.data
            };

        case 'MENU_PATCH_SUCCESS':
            return {
                ...state,
                refresh: true
            };

        case 'MENU_PATCH_FAILED':
            return {
                ...state,
                refresh: false
            };
            
        case 'MENU_REFRESH_TRUE':
            return {
                ...state,
                refresh: true
            };
            
        case 'MENU_REFRESH_FALSE':
            return {
                ...state,
                refresh: false
            };
            
        case 'MENUS':
            return initialState;
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/menu.js